(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mb-shard-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mb-shard-series')) {
    customElements.define('mb-shard-series', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('.mb-shard-toggle');
        this.toggle = () => this.setExpanded(!this.hasAttribute('expanded'));
        this.select = (event) => { if (this.contains(event.target) && event.target.closest('[data-shard-extra]')) this.setExpanded(true); };
        this.button?.addEventListener('click', this.toggle);
        document.addEventListener('shopify:block:select', this.select);
      }
      disconnectedCallback() {
        this.button?.removeEventListener('click', this.toggle);
        document.removeEventListener('shopify:block:select', this.select);
      }
      setExpanded(value) {
        this.toggleAttribute('expanded', value);
        if (!this.button) return;
        this.button.setAttribute('aria-expanded', String(value));
        this.button.firstChild.textContent = value ? 'Show less' : 'See more';
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mb-shard-v7"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('mb-shard-v7'))customElements.define('mb-shard-v7',class extends HTMLElement{
    connectedCallback(){this.button=this.querySelector('.shard-v7__more');this.toggle=()=>{const expanded=this.toggleAttribute('expanded');this.button.setAttribute('aria-expanded',String(expanded));this.button.textContent=expanded?'Show less':'See more';};this.button?.addEventListener('click',this.toggle);}
    disconnectedCallback(){this.button?.removeEventListener('click',this.toggle);}
  });

  } catch(e) { console.error(e); }
})();
})();
